import { serialize } from '@/@core/libs/serialize/util'
import Http from '@/services/httpAi'

export const profilesList = (params = '') => Http.get(`/admin/profiles${serialize(params)}`)
export const profileCreate = (params = '') => Http.post('/admin/profiles', params)
export const profileByID = (params = '') => Http.get(`/admin/profiles${params}`)
export const profileUpdate = (params = '') => Http.put(`/admin/profiles/${params.id}`, params)
export const profileDestroy = (params = '') => Http.delete(`/admin/profiles/${params.id}`)

